import { useQuery } from '@tanstack/react-query';
import { schoolClassificationApi } from '@/features/reports/api';
import { ApiError } from '@/shared/api';
import { isDashboardSchoolId } from './useSchoolClassificationDashboardQuery';

export const schoolClassificationComparisonQueryKeys = {
  all: ['school-classification', 'comparison'] as const,
  detail: (schoolId: string, year: number) =>
    [...schoolClassificationComparisonQueryKeys.all, schoolId, year] as const,
};

export function useSchoolClassificationComparisonQuery(
  schoolId: string | undefined,
  year: string | undefined,
  options?: { classificationWorkflowReady?: boolean }
) {
  const y = year && /^\d+$/.test(year.trim()) ? parseInt(year.trim(), 10) : NaN;
  const wf = options?.classificationWorkflowReady;
  const enabled =
    (wf !== false) && isDashboardSchoolId(schoolId) && Number.isFinite(y) && y > 0;

  return useQuery({
    queryKey: schoolClassificationComparisonQueryKeys.detail(schoolId ?? '', y || 0),
    queryFn: () => schoolClassificationApi.getSchoolComparison(schoolId!, y),
    enabled,
    retry: false,
  });
}

export function schoolClassificationComparisonErrorMessage(err: unknown): string {
  return err instanceof ApiError ? ApiError.getUserMessage(err) ?? err.message : 'Could not load peer comparison.';
}
